import socketIOClient from "socket.io-client";
import {allAgents, allDepartments, pushQueuedChat, allBannedUser, closeChat} from "../actions/actions";
import {helperFunctions} from "../lib/helperFunctions";
class ConnectionNode {
    constructor(dispatch, state) {


        this.socket = socketIOClient(process.env.REACT_APP_SERVER, {
            extraHeaders: {
                Authorization: state.bearer_token
            }
        });
        const socket = this.socket;
        this.socket.on("connect", () => {

            dispatch({
                type: "SET_CONNECTION",
                data: true
            })

        });


        this.socket.on("connect_error", () => {

            dispatch({
                type: "SET_CONNECTION",
                data: false
            });

        });

        this.socket.on("newDepartmentAdded", () => {
            dispatch(allDepartments());
        })
        this.socket.on("newAgentAdded", () => {
            dispatch(allAgents());
        });
		
		this.socket.on("newBanAdded", () => {
            dispatch(allBannedUser());
        });


        this.socket.on("updatedDepartment", (data) => {

            if (typeof data.data.departments[0] !== "undefined") {
                dispatch({
                    type: "OVERRIDE_DEPARTMENT",
                    data: {id: data.i, data: data.data.departments[0]}
                });
            }
        });
        this.socket.on("updateOperator", (data) => {

            dispatch({
                type: "OVERRIDE_AGENT",
                data: {id: data.i, data: data.data}
            });
			dispatch(allAgents());
				
        });

        this.socket.on("updateOperatorForKey", (data) => {
            dispatch({
                type: "UPDATE_AGENT",
                data: {id: data.id, key: data.key, val: data.val}
            });

        });

        this.socket.on("connectOperators", (id) => {
            dispatch({
                type: "UPDATE_AGENT",
                data: {id: id, key: "status", val: 1}
            });

        });
        this.socket.on("disconnectOperators", (id) => {
            dispatch({
                type: "UPDATE_AGENT",
                data: {id: id, key: "status", val: 0}
            });

        });

        this.socket.on("queued_visitor", (data) => {

            if (typeof data.chat !== "undefined") {
                if (typeof data.chat.id !== "undefined") {
                    dispatch(pushQueuedChat(data));



                }
            }

        });
        this.socket.on("read_customer_message",(data)=>{

            if (typeof data.chat_id !== "undefined") {

                dispatch({
                    type: "UPDATE_MESSAGE",
                    data: {
                        id: data.chat_id, filter_key: "id", up: [
                            {key: "read_user_state", val: 1}
                        ]
                    }
                });

            }
        });
        this.socket.on("read_agent_message",(data)=>{
            if (typeof data.chat_id !== "undefined") {
                dispatch({
                    type: "UPDATE_MESSAGE",
                    data: {
                        id: data.chat_id, filter_key: "id", up: [
                            {key: "read_agent_state", val: 1}
                        ]
                    }
                });

            }
        });
        this.socket.on("customerTypingMessage", (data) => {
            if (typeof data.chat_id !== "undefined") {
                dispatch({
                    type: "UPDATE_ACTIVE_CHAT",
                    data: {
                        id: data.chat_id, filter_key: "id", up: [
                            {key: "typing", val: 1},
                            {key: "typingMessage", val: data.message}
                        ]
                    }
                });

            }
        });
        this.socket.on("chat_vote_update",(data)=>{
            if(typeof data.chat_id!=="undefined"){
                dispatch({
                    type: "UPDATE_ACTIVE_CHAT",
                    data: {
                        id: data.chat_id, filter_key: "id", up: [
                            {key: "vote", val: {vote:data.vote}},
                        ]
                    }
                });
            }

        });
        this.socket.on("new_message",(data)=>{
            if(typeof data.chat_id!=="undefined"){


                if(typeof data.message!=="undefined"){
                    if(data.message.receiver!="1"){

                        helperFunctions.emitEvent('read_message', [{'chat_id' : data.chat_id}]);
                    }

                    dispatch({
                        type: "NEW_MESSAGE",
                        data: {
                            id: data.chat_id,
                            message: data.message,
                        }
                    });
                }
            }

            if(typeof data.last_message!=="undefined"){
                if(typeof data.chat_id!=="undefined"){
                    dispatch({
                        type: "UPDATE_ACTIVE_CHAT",
                        data: {
                            id: data.chat_id, filter_key: "id", up: [
                                {key: "last_message", val: data.last_message},
                            ]
                        }
                    });
                }

            }
        });
        this.socket.on("customerNoLongerTypingMessage", (data) => {
            if (typeof data.chat_id !== "undefined") {
                dispatch({
                    type: "UPDATE_ACTIVE_CHAT",
                    data: {
                        id: data.chat_id, filter_key: "id", up: [
                            {key: "typing", val: 0},
                            {key: "typingMessage", val: ""}
                        ]
                    }
                });

            }
        });

        this.socket.on("pick_from_chat",(data)=>{
            if(typeof data!=="undefined"){
                dispatch({
                    type: "UPDATE_ACTIVE_CHAT",
                    data: {
                        id: data, filter_key: "id", up: [
                            {key: "status", val: 'A'}
                        ]
                    }
                });
                socket.emit("join_chat_room", {chat_id: data});
            }
        });
        this.socket.on("queue_visitor_assigned",(data)=>{
            if(typeof data!=="undefined"){
                helperFunctions.emitEvent('closed_chat', [{'chat_id' : data.chat_id}]);
                dispatch({
                    type: "DELETE_ACTIVE_CHAT",
                    data: {id: data, filter_key: "id"}
                });
            }
        });


        this.socket.on("stop_supervise", (data) => {
            if (typeof data.chat_id !== "undefined") {
                dispatch({
                    type: "SET_SUPERVISE",
                    data: data.supervise
                });

                if(typeof data.close_chat==="undefined"){

                    dispatch({
                        type: "DELETE_ACTIVE_CHAT",
                        data: {id: data.chat_id, filter_key: "id"}
                    });
                }

                data['stop']=1;
                dispatch({
                    type: "SET_CUSTOMER_SUPERVISE",
                    data: data
                });
                socket.emit("leave_supervise_chat_room", data.chat_id);
            }

        });
        this.socket.on("close_chat_room", (data) => {

            if (typeof data.chat_id !== "undefined") {
                if (typeof data.agent !== "undefined" || typeof data.pending!=="undefined") {
                    helperFunctions.emitEvent('closed_chat', [{'chat_id' : data.chat_id}]);
                    dispatch({
                        type: "DELETE_ACTIVE_CHAT",
                        data: {id: data.chat_id, filter_key: "id"}
                    });

                } else {
                    dispatch({
                        type: "UPDATE_ACTIVE_CHAT",
                        data: {
                            id: data.chat_id, filter_key: "id", up: [
                                {key: "user_closed", val: 1}
                            ]
                        }
                    });
								/*helperFunctions.emitEvent('closed_chat', [{'chat_id' : data.chat_id}]);
								dispatch({
                                    type: "DELETE_ACTIVE_CHAT",
                                    data: {id:data.chat_id,filter_key:"id"}
                                });*/
					
					
                    //dispatch(closeChat({id:id}));
                }

                if (typeof data.pending === "undefined") {
                    socket.emit("leave_chat_room", data.chat_id);
                }
            }

        });
        this.socket.on("incoming_supervise", (data) => {
            if(typeof data.supervise!=="undefined"){
                dispatch({
                    type: "SET_SUPERVISE",
                    data: data.supervise
                });
                if(typeof data.chat_id!=="undefined"){
                    dispatch({
                        type: "SET_CUSTOMER_SUPERVISE",
                        data: data
                    });
                }
                if(typeof data.chat!=="undefined") {
                    dispatch({
                        type: "PUSH_ACTIVE_CHAT",
                        data: data.chat
                    });
                }
                socket.emit("join_supervise_chat_room", {chat_id: data.chat.id});


            }

        });


        this.socket.on("incoming_chat", (data) => {
            if (typeof data.chat !== "undefined") {
                if (typeof data.chat.id !== "undefined") {

                    socket.emit("join_chat_room", {chat_id: data.chat.id});

                    dispatch({
                        type: "PUSH_ACTIVE_CHAT",
                        data: data.chat
                    });
                    dispatch({
                        type: "SET_SOUND",
                        data: {
                            playing: true,
                            type: "incomingChat"
                        }
                    });

                }
            }

        });
        this.socket.on("updateUser",(data)=>{
            if(typeof data.mid!=="undefined"){

                dispatch({
                    type: "PUSH_CUSTOMER",
                    data: {mid: data.mid, data: data}
                });
            }


        });
        this.socket.on("disconnectUser", (user) => {

            dispatch({
                type: "DELETE_CUSTOMER",
                data: {id: user, filter_key: "mid"}
            });
            dispatch({
                type: "UPDATE_ACTIVE_CHAT",
                data: {
                    id: user, filter_key: "user_id", up: [
                        {key: "user_status", val: 0}
                    ]
                }
            });
        });
        this.socket.on("connectUser", (user) => {
            dispatch({
                type: "UPDATE_ACTIVE_CHAT",
                data: {
                    id: user, filter_key: "user_id", up: [
                        {key: "user_status", val: 1}
                    ]
                }
            });
        });


    }


}

export default ConnectionNode


